import { t } from 'i18next';
import { useEffect, useRef } from 'react';

export const useCalendarUrl = (year: number, month: number) => {
    const isInitialMount = useRef(true);

    useEffect(() => {
        const today = new Date();
        const currentMonth = today.getMonth() + 1;
        const currentYear = today.getFullYear();
        const currentHash = window.location.hash;

        if (isInitialMount.current && year === currentYear && month === currentMonth) {
            isInitialMount.current = false;
            return;
        }
        isInitialMount.current = false;

        const formattedMonth = String(month).padStart(2, '0');
        const baseUrl = t('calendar.url', { year, month: formattedMonth });
        window.history.pushState({ year, month }, '', baseUrl + currentHash);
    }, [month, year]);
};
